import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'mtg-table-col',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableColComponent {
  @HostBinding('class.table-cell')
  defaultClass = true;

  @HostBinding('class.highlight')
  get highlightClass() {
    return this.highlight;
  }

  @HostBinding('class.sortable')
  get sortableClass() {
    return this.sortable;
  }

  @Input()
  highlight: boolean;
  @Input()
  sortable: boolean;
}
